var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        { attrs: { id: "house", "clip-path": "url(#clip0_875_25689)" } },
        [
          _c("path", {
            attrs: {
              id: "Vector",
              d: "M13.9947 6.98633C13.9947 7.47852 13.6301 7.86406 13.2169 7.86406H12.4391L12.4561 12.2445C12.461 13.2152 11.7634 14.0027 10.9006 14.0027H3.11306C2.25508 14.0027 1.55751 13.218 1.55751 12.2527V7.8668H0.779731C0.342231 7.8668 0.00195312 7.48398 0.00195312 6.98906C0.00195312 6.74297 0.0748698 6.52422 0.245009 6.33281L6.47452 0.21875C6.64466 0.0273438 6.83911 0 7.00924 0C7.17938 0 7.37383 0.0546875 7.51966 0.191406L13.7273 6.33008C13.9217 6.52148 14.019 6.74023 13.9947 6.98633ZM8.55508 6.125C8.55508 5.66087 8.39119 5.21575 8.09947 4.88756C7.80774 4.55937 7.41208 4.375 6.99952 4.375C6.58696 4.375 6.1913 4.55937 5.89958 4.88756C5.60785 5.21575 5.44397 5.66087 5.44397 6.125C5.44397 6.58913 5.60785 7.03425 5.89958 7.36244C6.1913 7.69063 6.58696 7.875 6.99952 7.875C7.41208 7.875 7.80774 7.69063 8.09947 7.36244C8.39119 7.03425 8.55508 6.58913 8.55508 6.125ZM6.22174 8.75C5.14744 8.75 4.2773 9.72891 4.2773 10.9375C4.2773 11.1781 4.4523 11.375 4.66619 11.375H9.33286C9.54674 11.375 9.72174 11.1781 9.72174 10.9375C9.72174 9.72891 8.85161 8.75 7.7773 8.75H6.22174Z",
              fill: "#717986",
            },
          }),
        ]
      ),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_875_25689" } }, [
          _c("rect", { attrs: { width: "14", height: "14", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }